"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestionButton = exports.SuggestionContainer = void 0;
const button_1 = require("@pulse-web-ui/button");
const theme_1 = require("@pulse-web-ui/theme");
exports.SuggestionContainer = theme_1.styled.div `
  ${theme_1.mixins.flex({
    justifyContent: 'flex-start',
    verticalAlignment: 'center',
})}
`;
exports.SuggestionButton = (0, theme_1.styled)(button_1.Button) `
  ${theme_1.typography.regular14};
  line-height: 20px;
  padding: 4px 8px;
`;
